import React from 'react'
import { makeStyles } from '@mui/styles'
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded'

import lang from '@/lang'
import ThemeInterface from '@/theme-interface'
import openConfirmEmailModal from '@/modules/_helpers/openConfirmEmailModal'
import { EmailConfirmationBarHeight } from '@/themes/base'

const useStyles = makeStyles((theme: ThemeInterface) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    height: EmailConfirmationBarHeight,
    padding: '0px 30px',
    background: theme.palette.warning.background,
    color: theme.palette.warning.contrastText,
    fontSize: theme.fontSizes.small,
    lineHeight: 1.2,
  },
  icon: {
    fontSize: theme.fontSizes.medium,
    flex: '0 0 auto',
  },
  text: {
    flex: '1 1 auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  link: {
    flex: '0 0 auto',
    color: theme.primaryV2,
    fontWeight: theme.fontWeights.medium,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
}))

/**
 * DO-13065: slim warning bar above the whole desktop header for users whose address is not verified
 * yet but who are let in anyway. Visibility is decided by the parent (MenuV2) via
 * `useEmailConfirmationBar`, so the bar itself stays a dumb presentational row.
 * The CTA opens the DOI modal WITHOUT the logout option — this is a soft reminder, not the day-8 gate.
 */
const EmailConfirmationBar = () => {
  const classes = useStyles()

  return (
    <div className={classes.root} role='status' data-qs-id='email-confirmation-bar'>
      <WarningAmberRoundedIcon className={classes.icon} color='warning' />
      <span className={classes.text}>{lang.confirmEmail.pendingBar}</span>
      <a className={classes.link} onClick={() => openConfirmEmailModal()} data-qs-id='email-confirmation-bar-verify'>
        {lang.confirmEmail.verifyNow}
      </a>
    </div>
  )
}

export default EmailConfirmationBar
